import { t as H } from "./isDefined-fMi6eQ4r.js";
import { t as T } from "./theme-B90C-74v.js";
import { t as c } from "./mergeClassNames-BHKm1BNi.js";
import { t as I } from "./ListItem-Dp5FCrJm.js";
import { t as F } from "./Heading-DvxTKEaL.js";
import { i as P, n as x, r as O, t as S } from "./MenuSeparator-CcTm6JVY.js";
import { clsx as p } from "clsx";
import { jsx as t, jsxs as R } from "react/jsx-runtime";
import { isBoolean as y, isFunction as A } from "@sniptt/guards";
import { createContext as w, useContext as B } from "react";
import { useRender as g } from "@base-ui/react/use-render";
import { useDirection as M } from "@base-ui/react/direction-provider";
import { Menu as l } from "@base-ui/react/menu";
import { AlertDialog as u } from "@base-ui/react/alert-dialog";
import { Dialog as m } from "@base-ui/react/dialog";
var G = "_backdrop_19f4m_1", L = "_viewport_19f4m_12", $ = "_popup_19f4m_30", U = "_header_19f4m_79", j = "_body_19f4m_87", z = "_footer_19f4m_91", E = "_title_19f4m_102", V = "_description_19f4m_109", s = {
  backdrop: G,
  viewport: L,
  popup: $,
  header: U,
  body: j,
  footer: z,
  title: E,
  description: V
}, q = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.body, o)
  }
}), J = ({ className: e, ...r }) => /* @__PURE__ */ t(u.Description, {
  ...r,
  className: c(s.description, e)
}), K = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.footer, o)
  }
}), Q = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.header, o)
  }
}), W = ({ size: e = "md", container: r, keepMounted: o, className: a, ...i }) => {
  const d = T(), n = M();
  return /* @__PURE__ */ R(u.Portal, {
    container: r === void 0 ? d ?? void 0 : r,
    keepMounted: o,
    children: [/* @__PURE__ */ t(u.Backdrop, { className: s.backdrop }), /* @__PURE__ */ t(u.Viewport, {
      dir: n,
      className: s.viewport,
      children: /* @__PURE__ */ t(u.Popup, {
        ...i,
        "data-size": e,
        className: c(s.popup, a)
      })
    })]
  });
}, X = ({ className: e, ...r }) => /* @__PURE__ */ t(u.Title, {
  ...r,
  className: c(s.title, e)
}), Y = () => ({
  Root: u.Root,
  Trigger: u.Trigger,
  Popup: W,
  Title: X,
  Description: J,
  Close: u.Close,
  Header: Q,
  Body: q,
  Footer: K
}), je = /* @__PURE__ */ Y(), Z = "_cardContent_10wri_1", ee = { cardContent: Z }, re = ({ children: e, className: r, divider: o, isClickable: a, hasHoverHighlight: i, ...d }) => /* @__PURE__ */ t("div", {
  className: p(ee.cardContent, r),
  "data-divider": o || void 0,
  "data-clickable": a || void 0,
  "data-hover-highlight": i || void 0,
  ...d,
  children: e
}), ae = "_cardFooter_15rlh_1", oe = { cardFooter: ae }, te = ({ children: e, className: r, divider: o, ...a }) => /* @__PURE__ */ t("div", {
  className: p(oe.cardFooter, r),
  "data-no-divider": o === !1 || void 0,
  ...a,
  children: e
}), ie = "_cardHeader_yrli2_1", se = { cardHeader: ie }, de = ({ children: e, className: r, ...o }) => /* @__PURE__ */ t("div", {
  className: p(se.cardHeader, r),
  ...o,
  children: e
}), le = "_card_1cl8g_1", ne = { card: le }, me = ({ children: e, className: r, fullWidth: o, rounded: a, backgroundColor: i, style: d, ...n }) => /* @__PURE__ */ t("div", {
  className: p(ne.card, r),
  "data-full-width": o || void 0,
  "data-rounded": a || void 0,
  style: H(i) ? {
    ...d,
    "--card-background-color": i
  } : d,
  ...n,
  children: e
}), ze = {
  Root: me,
  Header: de,
  Content: re,
  Footer: te
}, ce = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.body, o)
  }
}), pe = ({ className: e, ...r }) => /* @__PURE__ */ t(m.Description, {
  ...r,
  className: c(s.description, e)
}), ue = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.footer, o)
  }
}), ve = ({ render: e, ref: r, className: o, ...a }) => g({
  render: e,
  ref: r,
  props: {
    ...a,
    className: p(s.header, o)
  }
}), fe = ({ size: e = "md", container: r, keepMounted: o, backdrop: a = !0, viewportProps: i, className: d, ...n }) => {
  const h = T(), v = M(), f = y(a) ? {} : a;
  return /* @__PURE__ */ R(m.Portal, {
    container: r === void 0 ? h ?? void 0 : r,
    keepMounted: o,
    children: [a !== !1 && /* @__PURE__ */ t(m.Backdrop, {
      ...f,
      className: c(s.backdrop, f.className)
    }), /* @__PURE__ */ t(m.Viewport, {
      dir: v,
      "data-backdrop-hidden": a === !1,
      ...i,
      className: c(s.viewport, i?.className),
      children: /* @__PURE__ */ t(m.Popup, {
        ...n,
        "data-size": e,
        className: c(s.popup, d)
      })
    })]
  });
}, _e = "_title_9tadl_1", ge = { title: _e }, he = ({ level: e = 2, size: r = "lg", color: o = "primary", className: a, render: i, ...d }) => /* @__PURE__ */ t(m.Title, {
  ...d,
  className: c(ge.title, a),
  render: /* @__PURE__ */ t(F, {
    level: e,
    size: r,
    color: o,
    render: i
  })
}), Ee = {
  createHandle: m.createHandle,
  Root: m.Root,
  Trigger: m.Trigger,
  Popup: fe,
  Title: he,
  Description: pe,
  Close: m.Close,
  Header: ve,
  Body: ce,
  Footer: ue
}, C = ({ color: e = "neutral", startIcon: r, endIcon: o, description: a, descriptionPlacement: i, hotkeys: d, disabled: n = !1, children: h, render: v, ...f }, D) => ({
  ...f,
  disabled: n,
  render: (b, N) => /* @__PURE__ */ t(I, {
    ...b,
    render: A(v) ? (_) => v(_, N) : v,
    color: e,
    disabled: n,
    startIcon: r,
    endIcon: o,
    description: a,
    descriptionPlacement: i,
    hotkeys: d,
    ...D?.(N),
    children: h
  })
}), Ne = (e) => /* @__PURE__ */ t(l.CheckboxItem, { ...C(e, (r) => ({
  indicator: "checkbox",
  selected: r.checked
})) }), Ce = (e) => /* @__PURE__ */ t(l.Item, { ...C(e) }), k = w(!1), De = {
  root: {
    side: "bottom",
    align: "start",
    sideOffset: 8,
    alignOffset: 0
  },
  submenu: {
    side: "inline-end",
    align: "start",
    sideOffset: 0,
    alignOffset: -4
  }
}, be = ({ side: e, align: r, sideOffset: o, alignOffset: a, anchor: i, keepMounted: d, className: n, children: h, ...v }) => {
  const f = T(), { container: D = f ?? void 0, ...b } = v, N = B(k), _ = De[N ? "submenu" : "root"];
  return /* @__PURE__ */ t(l.Portal, {
    container: D,
    keepMounted: d,
    children: /* @__PURE__ */ t(l.Positioner, {
      side: e ?? _.side,
      align: r ?? _.align,
      sideOffset: o ?? _.sideOffset,
      alignOffset: a ?? _.alignOffset,
      anchor: i,
      className: P.positioner,
      children: /* @__PURE__ */ t(l.Popup, {
        ...b,
        className: c(P.popup, n),
        children: h
      })
    })
  });
}, Pe = ({ className: e, ...r }) => /* @__PURE__ */ t(l.RadioGroup, {
  ...r,
  className: c(P.group, e)
}), Te = (e) => /* @__PURE__ */ t(l.RadioItem, { ...C(e, (r) => ({
  indicator: "check",
  selected: r.checked
})) }), Re = ({ children: e, ...r }) => /* @__PURE__ */ t(k.Provider, {
  value: !0,
  children: /* @__PURE__ */ t(l.SubmenuRoot, {
    ...r,
    children: e
  })
}), Me = (e) => /* @__PURE__ */ t(l.SubmenuTrigger, { ...C(e, () => ({ hasSubmenu: !0 })) }), Ve = {
  Root: l.Root,
  Trigger: l.Trigger,
  Popup: be,
  Item: Ce,
  CheckboxItem: Ne,
  RadioGroup: Pe,
  RadioItem: Te,
  Group: O,
  GroupLabel: x,
  Separator: S,
  SubmenuRoot: Re,
  SubmenuTrigger: Me
};
export {
  je as i,
  Ee as n,
  ze as r,
  Ve as t
};
